import { useState, useEffect, useCallback, useRef } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { MdOutlinePlayArrow } from "react-icons/md"
import { wrap } from "popmotion"

// const images = [
//   <img src={require("../assets/imgs/slide1.jpg")} alt="" />,
//   <img src={require("../assets/imgs/slide2.jpg")} alt="" />,
//   <img src={require("../assets/imgs/slide3.jpg")} alt="" />,
// ]
const images = [
  { img: "/imgs/promoted1.jpg", title: "Kilometers" },
  { img: "/imgs/promoted2.jpg", title: "Kilometers" },
  { img: "/imgs/promoted3.jpg", title: "Kilometers" },
]

const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity
}

const Promoted = () => {
  const intersectionObserver = useRef()

  const [loading, setLoading] = useState(false)
  const [mousedOver, setMousedOver] = useState(false)
  const [[page, direction], setPage] = useState([0, 0])

  const imageIndex = wrap(0, images.length, page)

  const paginate = useCallback(
    (newDirection) => {
      setLoading(true)
      setPage([page + newDirection, newDirection])
      setLoading(false)
    },
    [page]
  )

  const lastPostRef = useCallback(
    (node) => {
      if (intersectionObserver.current)
        intersectionObserver.current.disconnect()

      intersectionObserver.current = new IntersectionObserver(
        (nodes) => {
          if (nodes[0].isIntersecting && !mousedOver) {
            setMousedOver(true)
          } else {
            setMousedOver(false)
          }
        },
        {
          rootMargin: "-150px",
        }
      )

      if (node) intersectionObserver.current.observe(node)
    },
    [mousedOver]
  )

  useEffect(() => {
    let carouselTimeout
    if (mousedOver) {
      carouselTimeout = setTimeout(() => {
        paginate(1)
      }, 7000)
    }

    window.addEventListener("blur", () => {
      clearTimeout(carouselTimeout)
    })

    return () => {
      clearTimeout(carouselTimeout)
      window.removeEventListener("blur", () => {
        clearTimeout(carouselTimeout)
      })
    }
  }, [paginate, mousedOver])

  return (
    <section data-scroll-section className="carousel p-height c-promoted">
      <button
        disabled={loading}
        onClick={() => paginate(-1)}
        className="carousel-btn left"
      >
        <MdOutlinePlayArrow />
      </button>
      <motion.div ref={lastPostRef} className="carousel-items">
        <AnimatePresence mode="popLayout">
          <motion.div
            key={page}
            custom={direction}
            initial={{
              x: direction > 0 ? window?.innerWidth : -window?.innerWidth,
              zIndex: 0,
            }}
            animate={{ x: 0, zIndex: 1 }}
            transition={{
              duration: 1,
              ease: "anticipate",
            }}
            exit={{
              x: direction < 0 ? window?.innerWidth : -window?.innerWidth,
              scale: 0.98,
              zIndex: 0,
            }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(e, { offset, velocity }) => {
              const swipe = swipePower(offset.x, velocity.x)

              if (swipe < -swipeConfidenceThreshold) {
                paginate(1)
              } else if (swipe > swipeConfidenceThreshold) {
                paginate(-1)
              }
            }}
            className="carousel-item"
          >
            <div className="carousel-promoted-img">
              <img src={images[imageIndex].img} alt="" />
            </div>

            <motion.div
              className="carousel-item-title"
              initial={{
                scale: 0,
              }}
              animate={{ scale: 1 }}
              transition={{
                duration: 0.5,
                delay: 0.15,
              }}
              exit={{
                scale: 0,
              }}
            >
              <p>Dallol like the volcano.</p>
            </motion.div>
            <motion.div
              className="carousel-item-desc"
              initial={{
                scale: 0,
              }}
              animate={{ scale: 1 }}
              transition={{
                duration: 0.5,
                delay: 0.15,
              }}
            >
              <p>
                Dallol like the volcano. Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Quas suscipit quod repellendus molestias quos!
                Dolor.
              </p>
              <button className="btn-cta">Learn More</button>
            </motion.div>
          </motion.div>
        </AnimatePresence>
      </motion.div>
      <button
        disabled={loading}
        onClick={() => paginate(1)}
        className="carousel-btn right"
      >
        <MdOutlinePlayArrow />
      </button>
    </section>
  )
}

export default Promoted
